const HomeScreenLoading = (): JSX.Element | null => null;

export default HomeScreenLoading;
